document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  document.addEventListener('quickbuy:loaded', function(e) {
    if (!window.mz || !window.mz.track) {
      return
    }
    Array.from(
      document.querySelectorAll('.form.product-purchase-form .button.button--large')
    ).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.form;
        if (!form) { return; }
        var uid = form.getAttribute('data-product-id')
        if (uid) {
          window.mz.track('add2cart', { uid: uid })
        }
      })
    })
  });  

  function afterUpdate() {
    if (mz.app.filterLayout !== 'vertical' || mz.app.hits.total === 0) {
      document.querySelectorAll('.filter-container--side .filters').forEach(function(element) {
        element.classList.add('mz-hidden');
      })
    } else {
      document.querySelectorAll('.filter-container--side .filters').forEach(function(element) {
        element.classList.remove('mz-hidden');
      })
    }
    var mzHits = document.querySelector('.mz-hits')
    if (mzHits) {
      theme.manuallyLoadImages(mzHits)
    }
    var closeButton = document.querySelector('.show-search button.main-search__close')
    if (closeButton) {
      closeButton.click()
    }
    var closeDetail = document.querySelector('.expanded .quickbuy-container .close-detail')
    if (closeDetail) {
      closeDetail.click()
    } 
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})

// filter visibility
toggleFilter = function() {
  var aggs = document.querySelector('.mz-results');
  if (!aggs) {
    return;
  }   
  if(aggs.classList.contains('mz-collapsed-filter')) {
    aggs.classList.remove('mz-collapsed-filter');
  } else {
    aggs.classList.add('mz-collapsed-filter');
  }
  return false;
};

